import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";

import { Button } from "./ui/button.js";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu.js";
import { type Theme, useTheme } from "./theme-provider.js";

const options: ReadonlyArray<{
  readonly icon: typeof SunIcon;
  readonly label: string;
  readonly value: Theme;
}> = [
  { icon: SunIcon, label: "Light", value: "light" },
  { icon: MoonIcon, label: "Dark", value: "dark" },
  { icon: MonitorIcon, label: "Match my device", value: "system" },
];

export function ModeToggle() {
  const { resolvedTheme, setTheme, theme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label={`Color theme: ${options.find((option) => option.value === theme)?.label ?? "Match my device"}`}
          size="icon"
          variant="ghost"
        >
          {resolvedTheme === "dark" ? (
            <MoonIcon aria-hidden />
          ) : (
            <SunIcon aria-hidden />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36">
        <DropdownMenuRadioGroup
          onValueChange={(value) => setTheme(value as Theme)}
          value={theme}
        >
          {options.map(({ icon: Icon, label, value }) => (
            <DropdownMenuRadioItem key={value} value={value}>
              <Icon aria-hidden className="size-4" />
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
